import { vsingleton } from '@niknevis/vue-modules'
import RouteBase from '@niknevis/vue-modules/abstracts/RouteBase'
import route from 'ziggy-js'

const ROUTE_PREFIX: string = 'admin.content.'

@vsingleton()
export class AdminContentItemRoutes extends RouteBase {
  prefix = ROUTE_PREFIX + 'items.'

  index() {
    return this.ziggyRoute('index')
  }

  sendToQueue(itemId: number) {
    return this.ziggyRoute('send_to_queue', itemId)
  }

  sendToEditing(itemId: number) {
    return this.ziggyRoute('send_to_editing', itemId)
  }

  sendToCompleted(itemId: number) {
    return this.ziggyRoute('send_to_completed', itemId)
  }

  getDataForComplete(itemId: number) {
    return this.ziggyRoute('get_data_for_complete', itemId)
  }

  sendToReview(itemId: number) {
    return this.ziggyRoute('send_to_review', itemId)
  }

  show(itemId: number) {
    return this.ziggyRoute('show', itemId)
  }

  update(itemId: number) {
    return this.ziggyRoute('update', itemId)
  }

  saveContent(itemId: number) {
    return this.ziggyRoute('save_content', itemId)
  }

  downloadContent(itemId: number, format: string) {
    return route(this.prefix + 'download_content', { item: itemId, format: format })
  }

  updateItemManualDiscount(itemId: number) {
    return this.ziggyRoute('update_item_manual_discount', itemId)
  }

  getUpdatableAttributes(contentItemId: number) {
    return this.ziggyRoute('get_updatable_attributes', contentItemId)
  }

  changeProfit(itemId: number) {
    return this.ziggyRoute('change_profit', itemId)
  }

  exportExcel() {
    return this.ziggyRoute('export')
  }
}
